webpackJsonp([503],{

/***/ 1144:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  head: { "title": "如何贡献 | VUX - Vue 移动端 UI 组件库", "ignoreSuffixChar": "|" }
});

/***/ }),

/***/ 2098:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(1144),
  /* template */
  __webpack_require__(2892),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/data/vux/home/websites/vux-repo/docs/node_modules/v-markdown-loader/_cache/pr-156.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] pr-156.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-78a0c4cf", Component.options)
  } else {
    hotAPI.reload("data-v-78a0c4cf", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2892:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("如何贡献")]), _vm._v(" "), _c('h2', [_vm._v("文档更新")]), _vm._v(" "), _c('p', [_vm._v("如果修改了组件代码，需要在组件目录的"), _c('code', [_vm._v("metas.yml")]), _vm._v("加上changes，直接使用"), _c('code', [_vm._v("next")]), _vm._v("作为版本号(如果已经存在该版本号，则直接添加变更条目即可)。")]), _vm._v(" "), _c('p', [_vm._v("中括号内为变更类型，可选值 "), _c('code', [_vm._v("fix")]), _vm._v(" "), _c('code', [_vm._v("enhance")]), _vm._v(" "), _c('code', [_vm._v("feature")]), _vm._v(" "), _c('code', [_vm._v("change")])]), _vm._v(" "), _c('p', [_vm._v("比如：")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("changes:")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("  next:")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("    en:")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-bullet"
  }, [_vm._v("      -")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'[fix] fix *** bug #issueId'")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-bullet"
  }, [_vm._v("      -")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'[feature] new feature'")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("    zh-CN:")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-bullet"
  }, [_vm._v("      -")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'[fix] 修复 *** bug #issueId'")]), _vm._v("\n")])]), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_c('p', [_vm._v("当文档相关的 "), _c('code', [_vm._v("PR")]), _vm._v("被合并后，文档服务器会在"), _c('code', [_vm._v("5分钟")]), _vm._v("内拉取最新代码并执行"), _c('code', [_vm._v("npm run build-docs")]), _vm._v("及"), _c('code', [_vm._v("npm run build")]), _vm._v("实现文档及"), _c('code', [_vm._v("demo")]), _vm._v("更新。")])]), _vm._v(" "), _c('h2', [_vm._v("为什么使用 next 为版本号")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("next")]), _vm._v(" 表示下个版本，未发布时在 "), _c('code', [_vm._v("changelog")]), _vm._v(" 里显示 "), _c('code', [_vm._v("next")]), _vm._v("，提醒用户一些开发中的代码尚未发布。")]), _vm._v(" "), _c('p', [_vm._v("当进行版本发布时，文档中的 "), _c('code', [_vm._v("next")]), _vm._v(" 会被脚本代替成真正的版本号，至此发布完毕。")]), _vm._v(" "), _c('p', [_vm._v("这样的最大好处是更新代码时可以直接写 "), _c('code', [_vm._v("changelog")]), _vm._v(" 不用在意要写哪个版本号，在发布时翻 commit 记录写 "), _c('code', [_vm._v("changelog")]), _vm._v(" 是件比较浪费时间的事。")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-78a0c4cf", module.exports)
  }
}

/***/ }),

/***/ 562:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(2098);

/***/ })

});


// WEBPACK FOOTER //
// 503.def459b4.js